import React from 'react';
import { Box, Grid } from '@mui/material';

const DetailsPanel = ({ title, content, showPanel }: any) => {
  return (
    <>
      {showPanel && (
        <Grid container>
          <Grid item xs={12}>
            <Box
              sx={{
                bgcolor: '#FFEDD5',
                borderRadius: '8px 8px 0px 0px',
                fontWeight: '550',
                fontSize: '20px',
                fontStyle: 'normal',
                padding: '15px',
                color: '#F97316',
              }}
            >
              {title}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                boxShadow:
                  '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                bgcolor: '#FFFFFF',
                borderRadius: '8px 8px 0px 0px',
                padding: '15px',
              }}
            >
              {content}
            </Box>
          </Grid>
          <Grid item xs={12} paddingBottom={2}></Grid>
        </Grid>
      )}
      {!showPanel && content}
    </>
  );
};

export default DetailsPanel;
